import { IStepOption } from 'ngx-ui-tour-md-menu';

export const steps: IStepOption[] = [
    {
      anchorId: 'start-button',
      title: 'Bienvenido',
      content: 'Bienvenido al tour de la app de nvio!',
    },
    {
      anchorId: 'date-ranges',
      title: 'Rango de fechas',
      content: 'Aquí se puede establecer el rango de fechas con el que operaremos, podemos escoger entre rangos predeterminados o definir uno nosotros.'
    },
    {
      anchorId: 'main-cards',
      title: 'Estadísticas generales',
      content: 'Aquí mostramos datos estadísticos generales, como correos enviados, apertura, conversiones, etc...',
      route: '/main'
    },
    {
      anchorId: 'main-graph',
      title: 'Gráficas generales',
      content: 'También ofrecemos gráficas que dan una idea rápida de la evolución de las campañas.',
      route: '/main'
    },
    {
      anchorId: 'campaigns-cards',
      title: 'Estadísticas de campañas',
      content: 'Aquí mostramos datos estadísticos sobre las campañas, como correos enviados, apertura, conversiones, etc...',
      route: '/campaigns',
      stepDimensions: {
        minWidth: '350px'
      }
    },
    {
      anchorId: 'campaigns-start',
      title: 'Crear campaña',
      content: 'Pulsando aquí crearemos una nueva campaña',
      route: '/campaigns',
      stepDimensions: {
        minWidth: '300px'
      },
      placement: {
        yPosition: 'below',
        xPosition: 'before'
      }
    },
    {
      anchorId: 'campaigns-table',
      title: 'Campañas',
      content: 'En esta tabla están las campañas, podemos acceder a ellas pulsando sobre el nombre',
      route: '/campaigns'
    },
    {
      anchorId: 'lists',
      title: 'Listas',
      content: 'Aquí podemos gestionar nuestras listas y segmentos de envío. Las listas son estáticas y en los segmentos definiremos una regla y los perfiles entrarán y saldrán según la cumplan o no. Un ejemplo de segmento sería "Carrito abandonado"',
      route: '/lists'
    },
    {
      anchorId: 'new-list',
      title: 'Nueva lista o segmento',
      content: 'Pulsando aquí crearemos una lista o segmento.',
      route: '/lists',
      placement: {
        yPosition: 'below',
        xPosition: 'before'
      }
    },
    {
      anchorId: 'search-lists',
      title: 'Buscar en las listas',
      content: 'Escribiendo en este campo filtraremos las listas visibles.',
      route: '/lists'
    },
    {
      anchorId: 'table-lists',
      title: 'Listas y segmentos',
      content: 'En esta tabla están las listas y segmentos que hayamos definido. Pulsando sobre ellas podremos visualizarlas o editarlas',
      route: '/lists'
    },
    {
      anchorId: 'flows',
      title: 'Flujos de trabajo',
      content: 'Los flujos nos ayudan a automatizar nuestras comunicaciones de forma eficaz con los clientes adecuados en el momento adecudo.',
      route: '/flows'
    },
    {
      anchorId: 'new-flow',
      title: 'Crear flujo',
      content: 'Pulsando aquí, crearemos un nuevo flujo.',
      route: '/flows',
      placement: {
        yPosition: 'below',
        xPosition: 'before'
      }
    },
    {
      anchorId: 'table-flows',
      title: 'Lista de flujos',
      content: 'En esta lista encontraremos todos nuestros flujos, su estado y estadísticas sobre ellos.',
      route: '/flows'
    },
    {
      anchorId: 'profiles',
      title: 'Perfiles',
      content: 'Aquí tenemos todos los perfiles recogidos, podremos realizar búsquedas y acceder a los datos de cada uno de ellos.',
      route: '/profiles'
    },
    {
      anchorId: 'new-profile',
      title: 'Nuevo perfil',
      content: 'Pulsando aquí añadiremos un nuevo perfil a nuestra base de datos.',
      route: '/profiles',
      placement: {
        yPosition: 'below',
        xPosition: 'before'
      }
    },
    {
      anchorId: 'search-profiles',
      title: 'Buscar perfiles',
      content: 'Escribiendo en este campo filtraremos los perfiles visibles en la lista.',
      route: '/profiles'
    },
    {
      anchorId: 'templates',
      title: 'Plantillas de email',
      content: 'Aquí podremos gestionar nuestras plantillas de email, crear una nueva en blanco o a partir de diseños de la librería, duplicarlas o editarlas.',
      route: '/templates'
    },
    {
      anchorId: 'new-templates',
      title: 'Nueva plantilla',
      content: 'Pulsando aquí crearemos una nueva plantilla totalmente en blanco.',
      route: '/templates',
      placement: {
        yPosition: 'below',
        xPosition: 'before'
      }
    },
    {
      anchorId: 'search-templates',
      title: 'Buacar plantilla',
      content: 'Escribiendo en este campo filtraremos las plantillas visibles.',
      route: '/templates'
    },
    {
      anchorId: 'my-templates',
      title: 'Mis plantillas',
      content: 'Aquí están todas las plantillas que hemos creado.',
      route: '/templates'
    },
    {
      anchorId: 'templates-library',
      title: 'Librería',
      content: 'Aquí están los diseños predefinidos de NVio, pulsando sobre ellos los usaremos como base para una nueva plantilla.',
      route: '/templates'
    },
    {
      anchorId: 'popups',
      title: 'Popups',
      content: 'Aquí podremos gestionar nuestros popups web, crear uno nuevo en blanco o a partir de diseños de la librería, duplicarlos o editarlos.',
      route: '/popups'
    },
    {
      anchorId: 'new-popups',
      title: 'Nuevo popup',
      content: 'Pulsando aquí crearemos un nuevo popups totalmente en blanco.',
      route: '/popups',
      placement: {
        yPosition: 'below',
        xPosition: 'before'
      }
    },
    {
      anchorId: 'search-popups',
      title: 'Buscar popup',
      content: 'Escribiendo en este campo filtraremos los popups visibles.',
      route: '/popups'
    },
    {
      anchorId: 'my-popups',
      title: 'Mis plantillas',
      content: 'Aquí están todos los popups que hemos creado.',
      route: '/popups'
    },
    {
      anchorId: 'popups-library',
      title: 'Librería de popups',
      content: 'Aquí están los diseños predefinidos de NVio, pulsando sobre ellos los usaremos como base para un nuevo popup.',
      route: '/popups'
    },
  ];
